import { of } from 'rxjs/observable/of'
import { fromPromise } from 'rxjs/observable/fromPromise'
import {
  CREATE_CSV_APPRAISERS,
} from '../../pages/appraisers/actions'
import {
  setData,
} from '../../common/utils/resource'
import { API_VERSION } from '@app/api'

export default function createCsvAppraisers(action$, store, { API }) {
  return action$.ofType(CREATE_CSV_APPRAISERS).mergeMap(action => {
    return fromPromise(API('appraiser/upload', API_VERSION.TWO).request('POST', undefined, { data: action.data })).switchMap(_ => {
      return fromPromise(API('appraiser/', API_VERSION.TWO).request('GET')).switchMap(res => of(setData(res.results, { resource: { namespace: 'appraisers' } })))
    })
  })
};
